import { requestUrl } from "@/config/config";
import qs from "qs";

export const getConsumerRecordList = (params) =>
  `${requestUrl}/manage/menuApply/web/list?${qs.stringify(params)}`;

export const getComboSummary = (params) =>
  `${requestUrl}/manage/balanceChild/roleList?${qs.stringify(params)}`;

export const getTransactionDetails = (params) =>
  `${requestUrl}/manage/myMenu/list?${qs.stringify(params)}`;
export const exportConsumeDetail = `/consumedetail/exportConsumeDetail`;
export const getPayPage = () => `${requestUrl}/paycenter/list`;
export const consumerDetailPage = () => `/consumedetail/getConsumeDetail`;
